import "./Testimonials.css";

export default function Testimonials() {
  const data = [
    {
      name: "Naveen KP",
      text: "One of the best places to sell our gold. We got an accurate gold price. Good staff and well disciplined. Highly recommended. Thank you.",
    },
    {
      name: "Shashi Nayak",
      text: "I've been a loyal customer of Sell Gold for years and have never been disappointed with their services. They always offer fair prices and are very transparent in their dealings.",
    },
    {
      name: "Praveen Kumar",
      text: "I recently sold my gold jewelry to Sell Gold and was extremely impressed with their professionalism and honesty. They offered me a fair price and provided excellent customer service throughout the entire process.",
    },
  ];

  return (
    <section className="testimonial-section">

      <h2 className="testimonial-title">Testimonials</h2>

      <div className="testimonial-container">
        {data.map((item, index) => (
          <div className="testimonial-card" key={index}>

            <div className="stars">★★★★★</div>

            <p className="testimonial-text">"{item.text}"</p>

            <div className="testimonial-user">
              <div className="avatar">{item.name.charAt(0)}</div>
              <h4>{item.name}</h4>
            </div>

          </div>
        ))}
      </div>

    </section>
  );
}